import dayjs from 'dayjs';
import chunk from 'lodash/chunk';

export const formatter = (
  payload: string,
  splitValue: string,
  groupSize: number,
) => {
  // 去除 space -> split 後用 chunk 分組 -> 將每組結合成字串 -> 合併
  const subString = splitValue === ' ' ? /\s/g : splitValue;
  return chunk(payload.replace(subString, '').split(''), groupSize)
    .map((num) => num.join(''))
    .join(splitValue);
};

type formateType = 'date' | 'monthDate' | 'day' | 'full' | 'normal';

export const timeFormatter = (
  payload: string,
  type: formateType = 'normal',
) => {
  switch (type) {
    case 'date':
      return dayjs(payload).format('YYYY.MM.DD');
    case 'monthDate':
      return dayjs(payload).format('MM.DD');
    case 'day':
      return dayjs(payload).format('HH:mm');
    case 'full':
      return dayjs(payload).format('YYYY.MM.DD HH:mm:ss');
    default:
      return dayjs(payload).format('YYYY.MM.DD HH:mm');
  }
};
